<template>
	<div v-if="hasErrors">
		<div class="font-medium text-red-600">
			<i class="fa fa-triangle-exclamation"></i>
			Une erreur est survenue.
		</div>

		<ul class="mt-3 list-disc list-inside text-sm text-red-600">
			<li v-for="(error, key) in errorsSource" :key="key">
				{{ error }}
			</li>
		</ul>
	</div>
</template>

<script setup>
	import { computed, toRef } from 'vue';
	import { usePage } from '@inertiajs/vue3';

	const props = defineProps({
		errors: {
			type: Object,
			default: null,
		},
	});

	const page = usePage();

	const errorsSource = computed(() => {
		return props.errors ?? page.props.errors ?? {};
	});

	const hasErrors = computed(() => {
		return Object.keys(errorsSource.value || {}).length > 0;
	});
</script>
